import { FORUM_SECTION_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';

export function getForumSectionUrl(wixCodeApi) {
  return wixCodeApi.site.getSectionUrl({ sectionId: FORUM_SECTION_ID }).url || '';
}
